import React from 'react';
import { TailwindTooltip } from '../../atoms/TailwindTooltip';
import { CompilanceIcons } from '../../atoms/CompilanceIcons';
import { formatHumanDate } from '~/DateTime';

export interface CompilanceIconWithTooltipProps {
	compliance: string;
	title?: string | null;
	decisionComment?: string | null;
	referenceDataSourceVersion?: string | null;
	referenceDataSourceSince?: Date | null;
}

export function CompilanceIconWithTooltip({
	compliance,
	title,
	decisionComment,
	referenceDataSourceVersion,
	referenceDataSourceSince,
}: CompilanceIconWithTooltipProps) {
	return title ? (
		<TailwindTooltip
			reference={
				<>
					<CompilanceIcons compliance={compliance} />
					<span className='absolute right-full top-0 -mr-1 -mt-1 w-3 h-3 leading-3 rounded-full text-black not-italic text-[11px] font-semibold bg-white text-center'>
						?
					</span>
				</>
			}
			displayClass='inline-block mr-1 h-4 align-middle'
			position='left'
		>
			<p className='leading-snug'>{title}</p>
			{decisionComment && <p className='leading-snug pt-2 border-t border-gray-200'>{decisionComment}</p>}
			{referenceDataSourceSince && (
				<p className='leading-snug text-gray-500 text-[10px] tracking-wide'>
					Poznámky ref. zdroje {referenceDataSourceVersion} z&nbsp;
					{formatHumanDate(referenceDataSourceSince, ['cs-CZ'])}
				</p>
			)}
		</TailwindTooltip>
	) : (
		<div className='inline-block mr-1 h-4 align-middle'>
			<CompilanceIcons compliance={compliance} />
		</div>
	);
}
